"use client"

import { Button } from "@/components/ui";
import { AlertCircle, ArrowRight } from "lucide-react";
import Link from "next/link";

export const MissingSubscriptionBanner = () => {
  
return (
    <div className="bg-gradient-to-r from-yellow-600 to-yellow-400 text-white px-4 py-3 relative">
      <div className="container mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AlertCircle className="h-5 w-5 text-yellow-300" />
          <span>
            You're not using any <strong>Subscription</strong>. Choose Professional for more analyses, outreach emails, salary information and more!
          </span>
        </div>
        <div className="flex items-center space-x-2">
          <Link href="/subscribe">
            <Button size="sm" variant="secondary" className="">
              Choose now
              <ArrowRight className="ml-2 h-4 w-4" />
            </Button>
          </Link>
        </div>
      </div>
    </div>
)
}